var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtocols(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 1.59985V3.39985C14.6001 5.09665 14.6001 5.94505 15.1281 6.47185C15.6537 6.99985 16.5021 6.99985 18.2001 6.99985H20.0001",
    stroke: "#88888B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1999 11.7999H15.7999M6.1999 15.3999H15.7999M6.1999 18.9999H11.2039M1.3999 17.7999V8.19994C1.3999 4.80634 1.3999 3.10834 2.4547 2.05474C3.5083 0.999939 5.2063 0.999939 8.5999 0.999939H13.6063C14.0959 0.999939 14.3419 0.999939 14.5627 1.09114C14.7823 1.18234 14.9563 1.35514 15.3031 1.70314L19.8967 6.29674C20.2447 6.64474 20.4175 6.81754 20.5087 7.03834C20.5999 7.25794 20.5999 7.50394 20.5999 7.99354V17.7999C20.5999 21.1935 20.5999 22.8915 19.5451 23.9451C18.4915 24.9999 16.7935 24.9999 13.3999 24.9999H8.5999C5.2063 24.9999 3.5083 24.9999 2.4547 23.9451C1.3999 22.8915 1.3999 21.1935 1.3999 17.7999Z",
    stroke: "#88888B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocols);
export default __webpack_public_path__ + "static/media/protocols.6105b108455253c9dec34d1fbaddf9b8.svg";
export { ForwardRef as ReactComponent };